import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { Subscreens } from '../../constants/usage';
import { SearchBarContents } from './SearchBarContents';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchBar({
  productTypes,
  resultTypes
}) {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.SEARCH_BAR,
    children: /*#__PURE__*/_jsx(SearchBarContents, {
      productTypes: productTypes,
      resultTypes: resultTypes
    })
  });
}